import RoutesMenu from '@v2/domains/routing/components/BenestreamMenu/RoutesMenu'
import { BenestreamMenuConfig } from '@v2/domains/routing/types/routing.types'
import {
  getFilteredMenuItems,
  getFilteredSettingsMenuItems,
} from '@v2/domains/routing/utils/menu.utils'
import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'
import cx from 'classnames'
import { useState } from 'react'

import withErrorBoundaryAndPolicyCheck from '../../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import UserInformation from './UserInformation/UserInformation'
import logoSmallImg from './assets/benestream-small.png'
import logoImg from './assets/benestream.png'
import styles from './sidebar.module.scss'

const Sidebar = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)

  const logo = isSidebarCollapsed ? logoSmallImg : logoImg
  const policies = useAppSelector(selectPolicies)

  const regularItems = getFilteredMenuItems(
    'benestream',
    policies,
  ) as BenestreamMenuConfig[]
  const settingMenu = getFilteredSettingsMenuItems(policies)

  return (
    <div
      className={cx(
        styles.wrapper,
        isSidebarCollapsed && styles.collapsedWrapper,
      )}
    >
      <div className={cx(styles.inner, isSidebarCollapsed && styles.collapsed)}>
        <div onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>
          {isSidebarCollapsed ? (
            <img className={styles.logo} src={logo} />
          ) : (
            <img className={styles.logo} src={logo} />
          )}
        </div>

        <RoutesMenu menuItems={regularItems} isSidebarCollapsed={false} />

        <RoutesMenu
          menuItems={settingMenu}
          isSidebarCollapsed={false}
          showLogoutButton={true}
        />

        <UserInformation isSidebarCollapsed={isSidebarCollapsed} />
      </div>
    </div>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  Sidebar,
  'is_enable_benestream_sidebar',
  true,
)
